const accessTokenKey = 'accessToken';
const refreshTokenKey = 'refreshToken';
const tenantIdKey = 'tenantId';

// auth tokens related functions
export function getAuthTokens(): { access: string; refresh: string } {
  const accessToken = localStorage.getItem(accessTokenKey) || '';
  const refreshToken = localStorage.getItem(refreshTokenKey) || '';

  return { access: accessToken, refresh: refreshToken };
}

export function setAuthTokens(tokens: { access: string; refresh?: string }) {
  if (tokens.access) localStorage.setItem(accessTokenKey, tokens.access);
  if (tokens.refresh) localStorage.setItem(refreshTokenKey, tokens.refresh);
}

export function clearAuthTokens() {
  localStorage.removeItem(accessTokenKey);
  localStorage.removeItem(refreshTokenKey);
}

// tenant related functions
export function saveTenantId(tenantId: string) {
  localStorage.setItem(tenantIdKey, tenantId);
}

export function getTenantId(): string | null {
  return localStorage.getItem(tenantIdKey) || '';
}

export function removeTenantId() {
  localStorage.removeItem(tenantIdKey);
}
